<template>
  <div class="container">
    <b-modal
      v-model="showStartScreen"
      hide-backdrop
      hide-footer
      hide-header
      size="md"
      centered
      no-fade
      no-close-on-esc
      no-close-on-backdrop
      ok-only
      modal-class="login-form text-center"
    >
      <language-selection class="language"></language-selection>
      <b-container class="menu" v-model="showStartScreen">
        <div class="login-logo-container-div">
          <img class="login-logo-container" :src="logoUrl" />
        </div>
        <div
          class="btn btn-secondary login-button playasguest"
          @click="playAsGuest()"
        >
          <!-- TRY IT OUT NOW -->
          <span class="subheader">{{ $t("try_it_out_now") }}</span>
          <span class="subtext">
            {{ $t("try_it_out_now_button_sub_text") }}
          </span>
        </div>

        <div
          class="btn btn-tertiary login-button position-relative"
          id="azc-register-button"
          @click="authenticate"
        >
          <span class="subheader">{{ $t("register_button") }}</span>
          <span class="subtext"> {{ $t("register_button_sub_text") }}</span>
          <span class="freegift"></span>
        </div>

        <div
          class="btn btn-primary login-button"
          id="azc-login-button"
          @click="authenticate"
        >
          <span class="subheader">{{ $t("login") }}</span>
          <span class="subtext"> {{ $t("login_button_sub_text") }} </span>
        </div>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import Config from "../config/index";
import EventBus from "../core/EventBus";
import { Gamedock } from "../core/tracking/Gamedock";
import { generateQueryParamsFromObject } from "../core/utils/index";

export default {
  name: "LoginHelper",
  props: {
    isPopup: Boolean
  },
  components: {
    "language-selection": () => import("../components/LanguageSelection")
  },
  data() {
    return {
      logoUrl: `${Config.ASSET_URL}/game/images/${this.$store.getters.getGame.gameName}/login/logo.png`,
      backgroundUrl: `${Config.ASSET_URL}/game/images/${this.$store.getters.getGame.gameName}/landing_page/lp_background.jpg`,
      showStartScreen: true,
      pending: false
    };
  },
  computed: {},
  methods: {
    close() {
      this.$emit("close");
    },
    playAsGuest() {
      // if it is popup simply close the popup, cuz the user sees the popup as guest only
      this.close();

      // emit guest login for login page.
      this.$emit("guestLogin");
    },
    startScreen() {
      this.showStartScreen = true;
      const startScreen = document.querySelector(".splash-container");
      startScreen.style.display = "block";
    },
    authenticate(event) {
      const path =
        event.currentTarget.id === "azc-register-button" ? "register" : null;
      const link = this.prepareAuthLink(path);

      const popupWidth = 600;
      const popupHeight = 600;

      // Place the popup at the middle of screen
      const left = screen.width / 2 - popupWidth / 2;
      const top = screen.height / 2 - popupHeight / 2;

      const azcPopup = window.open(
        link,
        "_blank",
        `scrollbars=no,resizable=no, width=${popupWidth}, height=${popupHeight}, top=${top}, left=${left}`
      );
      if (azcPopup) azcPopup.focus();

      const vm = this;
      this.EventBus = new EventBus();
      this.EventBus.subscribe("AZC_LOGIN_SUCCESS", args => {
        this.$store
          .dispatch("loginUser", args)
          .then(newUser => {
            if (newUser)
              new Gamedock().registration(vm.$store.getters.getGame.gdGameId);

            azcPopup.close();
            vm.EventBus.broadcast("GAME_RELOAD");
          })
          .catch(err => console.log(err));
      });
      this.EventBus.subscribe("AZC_LOGIN_ERROR", args => {
        vm.EventBus.broadcast("NOTIFICATION", {
          success: false,
          message: args.message
        });
      });
    },
    prepareAuthLink(path) {
      const gameParams = {
        logo_url: this.logoUrl,
        background_url: this.backgroundUrl
      };
      const redirectUriParams = {
        game: this.$route.params.game,
        uid: this.$store.getters.getUser.uid
      };
      const networkCallbackUrl = `${
        Config.NETWORK_URL
      }/azc/login?${encodeURIComponent(
        generateQueryParamsFromObject(redirectUriParams)
      )}`;
      const loginOptions = {
        redirect_uri: networkCallbackUrl,
        locale: this.$store.getters.getLocale,
        response_type: "code",
        client_id: encodeURIComponent(Config.AZC_AUTH_CLIENT_ID)
      };

      // Just direct user to register page
      if (path) {
        loginOptions.action = path;
        loginOptions.redirect_uri = networkCallbackUrl;
      }

      const baseURL = `${Config.AZC_AUTH_URL}/realms/azerion/protocol/openid-connect`;
      const loginUrl = path ? baseURL + "/registrations" : baseURL + "/auth";
      const queryParams = generateQueryParamsFromObject({
        ...loginOptions,
        ...gameParams
      });
      return `${loginUrl}?${queryParams}`;
    }
  },
  beforeMount() {},
  mounted() {}
};
</script>
